var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMglassBarsSelected(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 21,
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F16334",
    d: "M13 21v-5h11v5H13zm10-4h-9v3h9v-3zM13 8h11v5H13V8zm1 4h9V9h-9v3zM13 0h11v5H13V0zm1 4h9V1h-9v3zm-3.086 11.621-2.766-2.766A5.055 5.055 0 1 1 1.74 5.033a5.055 5.055 0 0 1 7.115 7.116l2.766 2.766-.707.706zM9 9a4.042 4.042 0 0 0-8.082-.082 4.042 4.042 0 0 0 6.523 3.23l-.062-.063.707-.708.062.063A3.955 3.955 0 0 0 9 9z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMglassBarsSelected);
export default __webpack_public_path__ + "static/media/mglassBarsSelected.ed59ad897b4d263e61f915d6e979b83f.svg";
export { ForwardRef as ReactComponent };